import { useNavigate } from "react-router-dom";

// Pictures
import genliabImg from "../../assets/insurancelines/genLiab.png";
import profliabImg  from "../../assets/insurancelines/profLiab.png";
import workersImg  from "../../assets/insurancelines/workers.png";

// Icons
import genLiabilityIcon from "../../svg/genliability-icon.svg";
import proLiabilityIcon from "../../svg/proliability-icon.svg";
import workersIcon from "../../svg/workerscomp-icon.svg";

const lines = [
  {
    label: "GL",
    icon: genLiabilityIcon,
    title: "General Liability Insurance",
    description: "Protect your business from third-party claims involving bodily injury, property damage, and personal or advertising injury.",
    image: genliabImg,
  },
  {
    label: "PL",
    icon: proLiabilityIcon,
    title: "Professional Liability (E&O)",
    description: "Protect your business against claims of negligence, misrepresentation, or inaccurate advice. Essential for individuals and companies providing professional services.",
    image: profliabImg,
  },
  {
    label: "WC",
    icon: workersIcon,
    title: "Worker's Compensation Insurance",
    description: "Protect your employees and your business. Cover medical expenses, lost wages, and rehabilitation costs for work-related injuries or illnesses.",
    image: workersImg,
  },
];

// ── Insurance Card ──────────────────────────────────────────
function InsuranceCard({ line, onClick }) {
  return (
    <div
      className="bg-white-pure rounded-sm flex flex-col cursor-pointer group"
      style={{ boxShadow: "0 2px 12px rgba(1,46,114,0.08)" }}
      onClick={onClick}
    >
      <div className="relative w-full" style={{ height: "200px" }}>
        <img
          src={line.image}
          alt={line.title}
          className="w-full h-full object-cover rounded-t-sm"
        />
        <div
          className="absolute -bottom-6 right-6 flex items-center justify-center rounded-sm z-10"
          style={{ width: "52px", height: "52px", backgroundColor: "#012E72" }}
        >
          <img
            src={line.icon}
            alt=""
            className="w-7 h-7 object-contain"
            style={{ filter: "brightness(0) invert(1)" }}
          />
        </div>
      </div>

      <div className="flex flex-col flex-1 px-6 pt-7 pb-6">
        <h3 className="font-constantia text-blue-dark text-2xl font-bold mb-2">
          {line.title}
        </h3>
        <p className="font-times text-black-deep text-sm leading-relaxed">
          {line.description}
        </p>
        <br />
        <span
          className="font-times text-sm group-hover:underline"
          style={{ color: "#012E72" }}
        >
          Learn More →
        </span>
      </div>
    </div>
  );
}

// ── Section ─────────────────────────────────────────────────
export default function InsuranceLinesSection() {
  const navigate = useNavigate();

  return (
    <section className="w-full py-20 px-8 md:px-16" style={{ backgroundColor: "#F7F4EF" }}>

      <div className="max-w-6xl mx-auto flex items-end justify-between mb-10">
        <div>
          <div className="flex items-center gap-3 mb-4">
            <div className="h-px w-8" style={{ backgroundColor: "#012E72" }} />
            <span
              className="font-cinzel text-xs tracking-widest uppercase"
              style={{ color: "#012E72" }}
            >
              What We Offer
            </span>
          </div>

          <h2 className="font-cinzel text-4xl md:text-7xl font-bold leading-tight" style={{ color: "#012E72" }}>
            Tailored{" "}
            <span className="font-constantia italic font-normal">Coverage</span>
            <br />
            for Every Need
          </h2>
        </div>

        {/* CTA Button */}
        <button
          onClick={() => navigate("/services")}
          className="text-white-pure font-cinzel text-xs tracking-widest uppercase px-8 py-4 shrink-0 hover:opacity-90 transition-opacity"
          style={{ backgroundColor: "#012E72" }}
        >
          View All Coverages
        </button>
      </div>

      {/* Grid */}
      <div className="max-w-6xl mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {lines.slice(0, 3).map((line) => (
          <InsuranceCard
            key={line.title}
            line={line}
            onClick={() => navigate("/services")}
          />
        ))}
      </div>
    </section>
  );
}